<mat-drawer-container class="example-container" autosize>
  <mat-drawer #drawer class="example-sidenav" mode="over" position="end" style="width: 280px;">
    <mat-nav-list>
      <a mat-list-item (click)="downloadApp()">Picaggo App </a>
      <hr>
      <div style="position: relative; bottom: 0; width: 100%">
        <a mat-list-item target="_blank" href="https://picaggo.com/EULA.html">User Agreement</a>
        <a mat-list-item target="_blank" href="https://picaggo.com/PrivacyPolicy.html">Privacy Policy</a>
        <a mat-list-item (click)="logout()">Logout
          <!-- <mat-icon class="cursor">logout</mat-icon> -->
        </a>
      </div>
    </mat-nav-list>
  </mat-drawer>

  <div class="example-sidenav-content">
    <div class="container-fluid" style="
        position: sticky;
        top: 0;
       background-color: #eb3349;
        color: white;
        z-index: 10;
      ">
      <div class="row pt-2 pb-2 align-items-center">
        <div class="col-3">
          <mat-icon class="cursor" *ngIf="!eventDetail?.isAnnonymous" (click)="goBack()">keyboard_backspace</mat-icon>
        </div>
        <div class="col-6 text-center">
          <img class="img-icon-css cursor" src="assets/logo white.png" alt="Picaggo" style="padding-bottom: 5px;" />
          <p style="position: relative;font-size: 12px;margin-bottom: 0px;" class="text-uppercase white-color">
            Picaggo
          </p>
        </div>
        <div class="col-3 text-end">
          <mat-icon style="z-index: 1" class="cursor" (click)="drawer.toggle()">menu</mat-icon>
        </div>
      </div>
    </div>
    <div style="margin-top:4%">
      <h4 style="font-size: 22px !important;text-align: center;color: white;">Search My Pictures</h4>
      <div class="subText">Upload your picture to search for your images in the {{ albumLabel }}</div>
      <!-- <ng-template [ngIf]="!isFileLoading"> -->
      <div style="text-align: center;">
        <div>
          <div style="text-align: center;">
            <img *ngIf="prevImage != null" [src]="'data:image/jpeg;base64,' + prevImage" class="imgPlaceholder"
            alt="Navbar Background Image" />
           <img *ngIf="prevImage == null && !imageChangedEvent" src="/assets/icon/noun-selfie-large.png"
              class="imgPlaceholder" alt="Navbar Background Image" style="height: 250px;width: 250px;" /> 
            <div *ngIf="imageChangedEvent && errorMessage == null" class="row" style="margin: 15px;height: 250px;">
              <div class="text-center col-md-8">
                <!-- <h5>Crop Image</h5> -->
                <image-cropper  [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="3 / 3"
                  [resizeToWidth]="200" [roundCropper]="true" format="jpeg" (imageCropped)="imageCropped($event)"
                  (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()" style="height: 250px !important;"
                  (loadImageFailed)="loadImageFailed()"></image-cropper>
              </div>
            
            </div>
            <!-- <img *ngIf="prevImage == null" [src]="imageURL || '/assets/icon/noun-selfie-large.png'"
              class="imgPlaceholder" alt="Navbar Background Image" />
            <img *ngIf="prevImage != null" [src]="'data:image/jpeg;base64,' + prevImage" class="imgPlaceholder"
              alt="Navbar Background Image" /> -->
            <!-- <img [src]="imageURL" class="imgPlaceholder"> -->
            <div *ngIf="isFileLoading" class="loading" style="margin-top: 80px;">
              <h2>Uploading...</h2>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <br>
            <button *ngIf="prevImage != null && isFileLoading == false || errorMessage != null" class="btn btn-link"
              (click)="removeImage()" style="color: #f45c43;font-weight: bold;text-align: center;">Remove
              image</button>
            <div style="margin: 10px;" *ngIf="errorMessage != null" class="alert alert-danger">{{ errorMessage }}</div>
          </div>
          <br>
          <label style="width: 70%;" *ngIf="!imageChangedEvent && errorMessage == null"
            for="file-upload" class="file-upload-label">
            <span class="upload-text">Select Image </span>
          </label>
          <input id="file-upload" (change)="onFileSelected($event)" type="file"
            accept="image/png,image/jpg,image/jpeg,image/webp" class="file-upload-input">

        
        </div>
      </div>
      <div style="display: flex; justify-content: center !important; background: linear-gradient(to right, #eb3349, #f45c43);">
        <button *ngIf="imageChangedEvent && !isFileLoading" type="button" mat-raised-button   (click)="removeImage()" style="margin: 5px;">Cancel</button>
        <button *ngIf="isFileLoading" style="background-color: gray;margin: 5px;" disabled type="submit"
          mat-raised-button>Show My Pictures</button>
        <button *ngIf="!isFileLoading && imageChangedEvent && (prevImage != null || !hideBtn)" (click)="uploadImage()" type="submit" style="margin: 5px;"
          mat-raised-button>Show My Pictures</button>
      </div>
    </div>
  </div>

</mat-drawer-container>